import { render, staticRenderFns } from "./SolePropH.vue?vue&type=template&id=80cebd1a&scoped=true"
import script from "./SolePropH.vue?vue&type=script&lang=js"
export * from "./SolePropH.vue?vue&type=script&lang=js"
import style0 from "./SolePropH.vue?vue&type=style&index=0&id=80cebd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cebd1a",
  null
  
)

export default component.exports